import { Model, attr, fk } from 'redux-orm';

import ActionTypes from '../constants/ActionTypes';

export default class extends Model {
  static modelName = 'Item';

  static fields = {
    id: attr(),
    itemName: attr(),
    name: attr(),
    dataType: attr(),
    convertion: attr(),
    orderbyte: attr(),
    address: attr(),
    startBit: attr(),
    lengthBit: attr(),
    spanHigh: attr(),
    spanLow: attr(),
    initialValue: attr(),
    scanRate: attr(),
    unitName: attr(),
    readWrite: attr(),
    isIntegral: attr(),
    isSum: attr(),
    basic: attr(),
    color: attr(),
    decimalPoint: attr(),
    graphType: attr(),
    minValue: attr(),
    maxValue: attr(),
    position: attr(),
    modelId: fk({
      to: 'DeviceModel',
      as: 'deviceModel',
      relatedName: 'models',
    }),
  };

  static reducer({ type, payload }, Item) {
    switch (type) {
      case ActionTypes.ITEMS_FETCH_SUCCEEDED:
        payload.items.forEach((item) => {
          Item.upsert(item);
        });

        break;
      case ActionTypes.ITEM_UPDATE: {
        const item = Item.withId(payload.id);
        item.update(payload.data);
        break;
      }
      case ActionTypes.ITEM_DELETE:
        Item.withId(payload.id).deleteWithRelated();

        break;
      case ActionTypes.ITEM_CREATE_SUCCEEDED:
      case ActionTypes.ITEM_CREATE_RECEIVED:
        Item.upsert(payload.item);

        break;
      case ActionTypes.ITEM_UPDATE_RECEIVED:
        Item.withId(payload.item.id).update(payload.item);

        break;
      case ActionTypes.ITEM_DELETE_RECEIVED:
        Item.withId(payload.item.id).deleteWithRelated();

        break;
      default:
    }
  }

  static getOrderedQuerySet() {
    return this.orderBy(['modelId', 'position']);
  }

  deleteWithRelated() {
    this.alertSettings.delete();

    this.delete();
  }
}
